<div class="card-content">
  <!--共用：title 區域-->
  <h1 class="card-title">{{ 'id-login.title' | translate }}</h1>
  <p class="card-subtitle">{{ 'id-login.hint' | translate }}</p>
  <form [formGroup]="idLoginForm" (ngSubmit)="onSubmit()" class="login-form">
    <!--共用：企業/個人：input 區域-->
    @if (!isEnterprise) {
      <div class="input-block">
        <label class="input-title input-text-required" for="birthday">{{
          'id-login.birthday' | translate
        }}</label>
        <div class="input-group input-btn-right">
          <input
            id="birthday"
            matInput
            appDateInput
            [matDatepicker]="picker"
            [placeholder]="DATE_FORMAT"
            formControlName="birthday"
            [ngClass]="{
              'input-error': isFormSubmit && idLoginForm.get('birthday')?.invalid,
            }"
          />
          <mat-datepicker-toggle [for]="picker" class="input-date-btn">
            <ng-container matDatepickerToggleIcon>
              <img src="assets/img/i-calendar.svg" alt="" />
            </ng-container>
          </mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          @if (isFormSubmit && idLoginForm.get('birthday')?.invalid) {
            <mat-error class="input-error-msg"
              >{{ getBirthdayErrorMessage() }}
            </mat-error>
          }
        </div>
      </div>
    }

    <div class="input-block">
      <label class="input-title input-text-required" for="name">{{
        'id-login.name' | translate
      }}</label>
      <div class="input-group">
        <input
          id="name"
          matInput
          type="text"
          formControlName="name"
          appChineseEnglishSpaceOnly
          [placeholder]="'id-login.name-placeholder' | translate"
          [maxlength]="nameMaxLength"
          [ngClass]="{
            'input-error': isFormSubmit && idLoginForm.get('name')?.invalid,
          }"
        />
        @if (isFormSubmit && idLoginForm.get('name')?.invalid) {
          <mat-error class="input-error-msg"
            >{{ getNameErrorMessage() }}
          </mat-error>
        }
      </div>
    </div>
    <div class="input-block">
      <label class="input-title input-text-required" for="id-number">{{
        'id-login.id-number' | translate
      }}</label>
      <div class="input-group input-btn-right">
        <input
          id="id-number"
          matInput
          type="text"
          appMaskIdNumber
          [maskEnabled]="!isIdNumberVisible"
          formControlName="idNo"
          [placeholder]="'id-login.id-number-placeholder' | translate"
          [maxlength]="idNoMaxLength"
          [ngClass]="{
            'input-error': isFormSubmit && idLoginForm.get('idNo')?.invalid,
          }"
        />
        <button
          mat-icon-button
          type="button"
          class="input-password-btn"
          (click)="toggleIdNumberVisibility()"
        >
          <img
            [src]="
              isIdNumberVisible
                ? 'assets/img/i-eye.svg'
                : 'assets/img/i-eye-closed.svg'
            "
            alt="toggle visibility"
          />
        </button>
        @if (isFormSubmit && idLoginForm.get('idNo')?.invalid) {
          <mat-error class="input-error-msg"
            >{{ getIdNoErrorMessage() }}
          </mat-error>
        }
      </div>
    </div>

    <!--企業：input 區域-->
    @if (isEnterprise) {
      <!-- <div class="input-block">
        <label class="input-title input-text-required" for="enterprise-code">{{
          'id-login.enterprise-code' | translate
        }}</label>
        <div class="input-group">
          <input
            id="enterprise-code"
            matInput
            type="text"
            formControlName="enterpriseCode"
            [placeholder]="'id-login.enterprise-code-placeholder' | translate"
            [maxLength]="enterpriseCodeMaxLength"
            [ngClass]="{
              'input-error':
                isFormSubmit && idLoginForm.get('enterpriseCode')?.invalid,
            }"
          />
          @if (isFormSubmit && idLoginForm.get('enterpriseCode')?.invalid) {
            <mat-error class="input-error-msg"
              >{{ getEnterpriseCodeErrorMessage() }}
            </mat-error>
          }
        </div>
      </div> -->

      <!-- 若控制項用識別碼判別，顯示員工編號欄位 -->
      @if (controlItem === 1) {
        <div class="input-block">
          <label class="input-title" for="employee-number">{{
            'id-login.employee-number' | translate
          }}
          <!-- <span class="text-muted">{{ 'id-login.employee-number-hint' | translate }}</span> -->
          </label>
          <div class="input-group">
            <input
              id="employee-number"
              matInput
              type="text"
              formControlName="employeeNumber"
              appAlphaNumericOnly
              [placeholder]="'id-login.employee-number-placeholder' | translate"
              [maxLength]="employeeNumberMaxLength"
              [ngClass]="{
                'input-error':
                  isFormSubmit && idLoginForm.get('employeeNumber')?.invalid,
              }"
            />
            @if (isFormSubmit && idLoginForm.get('employeeNumber')?.invalid) {
              <mat-error class="input-error-msg"
                >{{ getEmployeeNumberErrorMessage() }}
              </mat-error>
            }
            <!-- <mat-checkbox [(ngModel)]="fillIdNumberChecked" [ngModelOptions]="{standalone: true}" (change)="onFillIdNumberChange($event.checked)">{{ 'id-login.fill-id-number' | translate }}</mat-checkbox> -->
          </div>
        </div>
      }
      <div class="input-block">
        <label class="input-title input-text-required" for="identity">{{
          'id-login.identity' | translate
        }}</label>
        <mat-radio-group id="identity" formControlName="identity">
          <mat-radio-button [value]="API_PARAMS.IDENTITY.EMPLOYEE"
            >{{ 'id-login.identity-employee' | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="API_PARAMS.IDENTITY.EMPLOYEE_DEPENDENTS"
            >{{ 'id-login.identity-employee-dependents' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    }

    <!--共用：開始預約 btn-->
    <button mat-button type="submit" class="btn-fill-primary btn-size-l" [disabled]="appointmentProcessing">
      {{ 'id-login.button.reserve' | translate }}
    </button>
  </form>
</div>
